import { ToastPosition } from 'react-toastify'

export enum TOAST_TYPES {
  error = 'error',
  success = 'success',
  warning = 'warning',
  info = 'info',
}

export interface Toast {
  title: string
  description?: string
  duration?: number
  type: TOAST_TYPES
  position?: ToastPosition
  containerId?: string
}
